import {
  differenceInDays,
  differenceInHours,
  differenceInMinutes,
  format,
  isThisYear,
} from 'date-fns';

/** How long ago a note was written: "5m", "3h", "8d", then the date. */
export const formatNoteAge = (date: Date) => {
  if (isNaN(date.getTime())) return '';
  const now = new Date();
  const minutes = differenceInMinutes(now, date);
  if (minutes < 1) return 'now';
  if (minutes < 60) return `${minutes}m`;
  const hours = differenceInHours(now, date);
  if (hours < 24) return `${hours}h`;
  const days = differenceInDays(now, date);
  if (days < 30) return `${days}d`;
  return format(date, isThisYear(date) ? 'MMM d' : 'MMM d, yyyy');
};
